import { IconFileInvoice, IconHome, IconWorld } from "@tabler/icons-react";
const InvoiceMenu = {
  id: "invoices",
  title: "Invoices",
  type: "collapse",
  caption: "",
  icon: IconFileInvoice,
  children: [
    {
      id: "Domestic",
      title: "Domestic",
      type: "item",
      url: "/portal/admin/invoices/domestic",
      icon: IconHome,
    },
    {
      id: "International",
      title: "International",
      type: "item",
      url: "/portal/admin/invoices/international",
      icon: IconWorld,
    },
  ],
};

export default InvoiceMenu;
